export default __webpack_public_path__ + "static/media/SourceSansPro-Light.81652e56.TTF";